import React from "react";
import { ImageComponent } from "../../images";
import { ReactComponent as GithubIcon } from "../../images/github-icon.svg";
import { ReactComponent as LinkedInIcon } from "../../images/linkedin-icon.svg";
import { ReactComponent as MailIcon } from "../../images/mail-icon.svg";
import UserData from "../../userdata.json";
function Intro() {
  const { intro, socials } = UserData || {};
  const { github, linkedin, mail } = socials || {};
  return (
    <div id="Home" className="pt6  flex justify-center flex-column items-center">
      <div className="w5-l w4 h4 h5-l br-100 white-shadow">
        {intro?.avtar ? (
          <ImageComponent
            path={intro?.avtar}
            className="w5-l w4 br-100 white-shadow white-shadow"
          />
        ) : null}
      </div>
      <span className=" mt4 fw9 f1-l f3 hover-tertiary pointer transition-color">
        Hi, I'm {intro?.name || "Your Name"}
      </span>
      <div className="mt3 f3-l f4 center flex flex-column justify-center items-center w-40-l">
        <span className="text-align-center">
          {intro?.tagline || "your tagline"}
        </span>
      </div>
      <div className="mt4 flex">
        {mail ? (
          <a
            className="glassmorphic-2 ba pa3  br-100 svg-path-stroke-tertiary pointer mr3 "
            href={`mailto:${mail}`}
          >
            <MailIcon
              // width={25}
              // height={25}
              className="primary w1 h1 svgstroke-transition"
            />
          </a>
        ) : null}
        {github ? (
          <a
            href={github}
            target="_blank"
            rel="noreferrer"
            className="ba glassmorphic-2 pa3  br-100 svg-path-fill-tertiary pointer mr3"
          >
            <GithubIcon
              // width={25}
              // height={25}
              className="primary w1 h1  svgfill-transition"
            />
          </a>
        ) : null}
        {linkedin ? (
          <a
            href={linkedin}
            target="_blank"
            rel="noreferrer"
            className="ba glassmorphic-2 pa3  br-100 svg-path-fill-tertiary pointer "
          >
            <LinkedInIcon
              // width={25}
              // height={25}
              className="primary w1 h1  svgfill-transition"
            />
          </a>
        ) : null}
      </div>
      <a
        href={mail?`mailto:${mail}`:""}
        className="glassmorphic-2 ba primary pa3 ph5 br3 mt4 button-transition pointer no-underline"
      >
        Contact me
      </a>
    </div>
  );
}

export default Intro;
